<template>
    <div class="app">
        <AppHeader/>
       
        <b-container fluid>
          <router-view></router-view>
           
        </b-container>
        <b-navbar toggleable="lg" type="dark" class="mt-5" variant="primary">
          <b-navbar-brand href="javascript:void(0)">
            <i><u>{{$t('logoName')}}</u></i> 
          </b-navbar-brand>
        </b-navbar>
   </div>
</template>

<script>
import AppHeader from '../components/AppHeader';
export default {
    
  name: 'Full',
  components: {
    AppHeader
  },
  data(){
    return {
      parentMenu:"project"
    }
  },
  computed: {
    
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched
    }
  }
  
}
</script>

